import React from 'react';
import pull = require("lodash/pull");
import FontIcon from 'material-ui/FontIcon';
import {MdTextField} from 'core/components/fields/fields';
import {lovLabel, FormProps, ClosedContentProps} from 'core/form/formUtils';
import {createForm} from 'core/form/createForm';
import StyledSelect from 'core/components/fields/styledSelect';
import {BlockComp} from 'core/components/blockComp/blockComp';
import {MdIconButton} from "core/components/buttons/icons";
import ActiveItem from 'core/components/blockComp/activeItem';
import {Validate} from 'core/form/validate';
import Add from "material-ui/svg-icons/content/add";
import {addSeparator} from "core/common/utils/arrayUtils";
import {MdDivider} from "core/components/blockComp/blockComp";
import {Party, PartyContact} from "party/partyDomain";
import {ObservableMap, action, observable} from "mobx";
import MdEntity from "core/metamodel/mdEntity";
import {observer} from "mobx-react";
import {grey500, indigo500} from "material-ui/styles/colors";
import {invalid, valid, validWarn} from "../../core/form/rules";
import partyService from "../partyService";
import {QRCode} from "react-qr-svg";


interface PartyContactListProps {
  partyObject: Party;
  rootObject: Party;
  entities: ObservableMap<MdEntity>;
}

const ViberUserCheck = ({value}): any => {
  if (!value) return valid();
  return partyService.viberUserCheck({id: value})
    .then( (exists) => (exists === true) ? valid() : invalid("User not found"));
}

@observer
export default class PartyContactList extends React.Component<PartyContactListProps, undefined> {


  @action addContact = () => {
    console.debug('addContact');
    const {partyObject, rootObject, entities} = this.props;
    let newContact = new PartyContact({$new: true, $added: true}).initDefaultValues();
    partyObject.contacts.push(newContact);
    rootObject.$dirty = true;
  };



  render() {

    const {partyObject, entities, rootObject} = this.props;

    const header = (
      <div style={{display: 'flex', alignItems: 'center'}}>
        <div>Contacts</div>
        <MdIconButton onClick={this.addContact}>
          <Add />
        </MdIconButton>
      </div>
    );

    return (
      <BlockComp header={header}  noPadding={true} style={{display: 'flex', flexDirection: 'column'}} >
        {
          addSeparator( partyObject.contacts.map((contact, index) => <PartyContactForm dataObject={contact} rootObject={partyObject} key={index}
                                                                                              entities={entities} entity={entities.get('PartyContact')}
                                                                                               index={index} /> ), <MdDivider inset/>)
        }
      </BlockComp>
    );
  }
}

const ClosedContent = ({dataObject, entity, entities, fields}: ClosedContentProps<PartyContact>) => {

  const PARTYCONTACTCATEGORY = entities.get('PARTYCONTACTCATEGORY');
  let catLov =  (dataObject.contactType) ? PARTYCONTACTCATEGORY.getLovItem(dataObject.contactType.category) : null;

  return (
    <div style={{display: 'flex', fontSize: 14, lineHeight: '14px'}}>
      <FontIcon className={(catLov) ? catLov["icon"] : ''} color={indigo500} style={{fontSize:16}}/>
      <div style={{display: 'flex', flexDirection: 'column', marginLeft: 20, wordBreak: 'break-all'}}>
        <div>{dataObject.value}</div>
        <div style={{fontSize:12, color: grey500, marginTop: 2}}>{lovLabel(dataObject.contactType)}</div>
        { (dataObject.comment) ? (
            <div style={{fontSize:12, color: grey500, marginTop: 2}}>{dataObject.comment}</div>) : ''}
      </div>
    </div>
  )};

@createForm({
  formName: 'PartyContactForm',
  fields: [{
    name: 'value',
    validators: ['IsRequired'],
    style: {marginRight: 5}
  }, {
    name: 'comment'
  }, {
    name: 'contactType',
    validators: ['IsRequired']
  }]
}, ClosedContent)
@observer
class PartyContactForm extends React.Component<FormProps<PartyContact, Party>, undefined> {

  @action onDelete = (evt) => {
    evt.stopPropagation();
    console.log('onDelete %o', this.props.dataObject);
    pull(this.props.rootObject.contacts, this.props.dataObject);
  };

  @observable
  viberBotUrl: string

  fetchViberBotUrl = async () => {
    const {dataObject} = this.props;

    if(!this.viberBotUrl && !!dataObject.contactType && dataObject.contactType.label == "viber") {
      this.viberBotUrl = await partyService.getViberBotUrl();
    }
  };

  componentDidMount = this.fetchViberBotUrl
  componentDidUpdate = this.fetchViberBotUrl

  render() {

    const {dataObject, entity, formName, rootObject, index, entities} = this.props;
    let fields = dataObject.getFormFields(formName);
    let {value, comment, contactType} = fields;

    const isViberContact = !!dataObject.contactType && dataObject.contactType.label == "viber";

    const openContent = (
      <div style={{display: 'flex', flexDirection: 'column'}}>
        <div style={{display: 'flex', flexDirection: 'row'}}>
          <MdTextField {...value.props}   />
          <Validate field={value} value={value.props.value}/>
          {isViberContact &&
          <Validate field={value} value={value.props.value}>
            <ViberUserCheck/>
          </Validate>}
          <StyledSelect {...contactType.props}/>
          <Validate field={contactType} value={contactType.props.value}/>
        </div>
        {isViberContact &&
        <div style={{display: 'flex', flexDirection: 'column'}}>
          {this.viberBotUrl &&
          <QRCode
            level="L"
            style={{marginTop: "20px"}}
            value={this.viberBotUrl}
          />
          }
          <div style={{marginTop: "15px"}}>
            Scan this QR code to open the bot profile. Send a message to the bot and you will get back your user ID.
            Enter it here as the value.
          </div>
        </div>
        }
        <MdTextField {...comment.props}/>
      </div>
    );


    return (
      <ActiveItem openContent={openContent} closedContent={<ClosedContent {...{dataObject, entity, entities, fields}} />} key={index} onDelete={this.onDelete} validate={this.props.validate} {...this.props} />
    );
  }
}





// WEBPACK FOOTER //
// ./src/party/component/partyContactList.tsx